module.exports = __webpack_public_path__ + "static/img/badge-service-request-active.9b34284.svg";